var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-page"},[(_vm.type==='express')?_vm._l((_vm.routeConfig.children),function(item,index){return _c('div',{key:index},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('menu-lst',{attrs:{"router":item}})],1)}):_vm._e(),_vm._v(" "),(_vm.type==='service')?[_c('menu-lst',{attrs:{"router":_vm.routeConfig}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ee363c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/product/list/index.vue
// module id = null
// module chunks = 